import React, { Component } from "react";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Button } from "react-bootstrap";
import AddressZone from "../Zone_Management/zone/AddressZone";
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Col, CardBody } from "reactstrap";
import GeoCoding from "../transaction/order/GeoCoding";
import SimpleReactValidator from 'simple-react-validator';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Create';
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dateFormat from 'dateformat';
import { connect } from "react-redux";
import 'moment/locale/fr.js' // or 'rc-datepicker/node_modules/moment/locale/fr.js' if you don't have it in your node_modules folder
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import moment from "moment";
import { toast } from 'react-toastify';

class TankDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerData: [], associateId: "", Data: [], toggleAddress: false, toggleCheckAddress: false, address: ""
            , label: "", zoneFlag: false, disableSubmit: false, lat: "", lng: "", zone: "", editPrice: false, statusUpdate: false,
            customerId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
            fromDate: "", toDate: "", fromDate1: "", toDate1: "", pricePerKL: "", selectDate: "", selectDate1: "",
            contractPriceToDate: "", contractPriceFromDate: "", addressId: "", apartmentRenewalStatus: ""
        };
        this.nextPath = this.nextPath.bind(this);
        this.addressValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
        this.pdValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
    }

    nextPath(path, value) {
        this.props.history.push({ pathname: path, data: value, state: { data: value } });
    }

    componentDidMount() {
        const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/getACbyId/" + this.state.customerId
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            }
        }).then(
            response => { return response.json(); }
        ).then(data => {
            this.setState({ customerData: data[0] }, () => this.getAllAddress(data[0].apartmentId)
            )
            // if (data !== "") {

            //     this.fetchContractPrice(data[0].apartmentId)
            // }
        }
        )

    }

    // fetchContractPrice = (Id) => {
    //     const url5 = "/api/contractPrice/getCPbyAssociateId/" + Id
    //     fetch(url5).then(
    //         response => {
    //             if (!response.ok) throw new Error(response.status);
    //             else return response.json();
    //         }
    //     ).then(data => {
    //         this.setState({ fromDate: dateFormat(data[0].fromDate, "dd-mm-yyyy"), contractPriceFromDate: data[0].fromDate, toDate: dateFormat(data[0].toDate, "dd-mm-yyyy"), contractPriceToDate: data[0].toDate, pricePerKL: data[0].pricePerKL });
    //     }).catch(error => console.log(error), this.setState({ priceData: "" }))
    // }

    myCallback = (dataFromChild) => {
        this.setState({ lat: dataFromChild.lat, lng: dataFromChild.lng, address: dataFromChild.fullAddress })
    }

    getAllAddress(value) {
        this.setState({ associateId: value });
        const url5 = process.env.REACT_APP_NODE_ENV + "/api/address/getAddressbyCustomerId/" + value
        fetch(url5, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            }
        }).then(
            response => {
                if (!response.ok) throw new Error(response.status);
                else return response.json();
            }
        ).then(data => {
            this.setState({ Data: data });
        }).catch(error => console.log(error), this.setState({ Data: [] }))
    }

    newAddress1 = () => {
        this.setState({ toggleAddress: true })
    };

    newAddressClickEventHandler = () => {
        this.setState({ toggleCheckAddress: true });
    };

    myZoneCallback = (dataFromChild) => {
        this.setState({ zone: dataFromChild, zoneFlag: false });
        if (!this.state.zoneFlag) {
            this.addAddress();
        }
    }

    addAddress = () => {
        this.addNewAddress();
    }
    addNewAddress = () => {
        if (this.addressValidator.allValid()) {
            const { associateId, address, lat, lng, label } = this.state;
            let postAddressData = {
                associateId: associateId, defaultAddress: "No",
                fullAddress: address, geolocationLat: lat, geolocationLng: lng, label: label
            };
            fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
                },
                body: JSON.stringify(postAddressData)
            }).then(response => {
                response.json();
                if (response.status === 406) {
                    toast.error("Address already exist.", {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            })
                .then((data) => {
                    this.addressValidator.hideMessages();
                    this.setState({
                        address: "", lat: "", lng: "", zone: "", label: "",
                        toggleAddress: false,
                        toggleCheckAddress: false, zoneFlag: false, disableSubmit: false
                    }, () => this.componentDidMount())
                })
                .catch(error => console.log(error))
        } else {
            this.addressValidator.showMessages();
            this.forceUpdate();
        }
    }

    newAddressHandler = event => {
        switch (event.target.id) {
            case "address":
                this.setState({ address: event.target.value }); break;
            case "adlabel":
                this.setState({ label: event.target.value }); break;
            default: break;
        }
    }

    toggleNewAddressModal = () => {
        this.setState({ disableSubmit: true }, () => this.addNewAddress());
    };

    toggleNewAddressModalCancel = () => {
        this.addressValidator.hideMessages();
        this.setState({ toggleAddress: false, toggleCheckAddress: false, address: "", label: "" })
    }

    handleUserFormFields = event => {
        this.pdValidator.showMessageFor(event.target.name)
        switch (event.target.id) {
            case "pdFromDate":
                this.setState({ fromDate: event.target.value, statusUpdate: true });
                break;
            case "pdToDate":
                this.setState({ toDate: event.target.value, statusUpdate: true });
                break;
            case "pdPricePerKL":
                this.setState({ pricePerKL: event.target.value, statusUpdate: true });
                break;
            default:
                break;
        }
    };

    save = () => {
        if (this.pdValidator.allValid()) {

            let postOrderData = "";
            if (this.state.statusUpdate) {
                postOrderData = {
                    "CPfromDate": this.state.contractPriceFromDate,
                    "CPtoDate": this.state.contractPriceToDate,
                    "pricePerKL": this.state.pricePerKL,
                    "associateId": this.state.customerData.apartmentId,
                    "apartmentRenewalStatus": this.state.apartmentRenewalStatus,
                    "id": this.state.addressId
                }
                fetch(process.env.REACT_APP_NODE_ENV + '/api/address/updateAddress', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
                    },
                    body: JSON.stringify(postOrderData)
                }).then((res) => res.json())
                    .then((data) => {
                        this.setState({ contractPriceFromDate: "", contractPriceToDate: "", pricePerKL: "", editPrice: false })
                        this.componentDidMount()
                    })
                    .catch((err) => console.log(err))
            }
            else {
                this.componentDidMount();
            }
        }
    }

    popUpCancel = () => {
        this.setState({ editPrice: false, statusUpdate: false });
    }

    editPriceHandler = (value) => {
        const doesToggle = this.state.editPrice;
        this.setState({
            contractPriceFromDate: value.CPfromDate, contractPriceToDate: value.CPtoDate, apartmentRenewalStatus: "RENEWED",
            pricePerKL: value.pricePerKL, addressId: value.id, editPrice: !doesToggle
        });
    };

    handleChange2 = date => {
        this.setState({ contractPriceFromDate: date, statusUpdate: true });
    };

    handleChange3 = date => {
        this.setState({ contractPriceToDate: date, statusUpdate: true });
    };

    render() {

        const dataArr = [];
        this.state.Data.map((data) => {
            let cpFromDate = "", cpToDate = ""
            if (data.CPfromDate === null) cpFromDate = ""
            else cpFromDate = dateFormat(data.CPfromDate, "dd-mm-yyyy")
            if (data.CPtoDate === null) cpToDate = ""
            else cpToDate = dateFormat(data.CPtoDate, "dd-mm-yyyy")
            let mdData = [
                data.label, data.fullAddress, cpFromDate, cpToDate, data.pricePerKL, data
            ]
            dataArr.push(mdData)

            return null;
        });
        const columns = [
            {
                name: "label",
                label: "Title",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "address",
                label: "Address",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpFromDate",
                label: "CP From Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpToDate",
                label: "CP To Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "pricePerKL",
                label: "Price Per KL",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "actions",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <Tooltip title="Edit"><IconButton><EditIcon onClick={() => this.editPriceHandler(value)} />
                            </IconButton></Tooltip>
                        );
                    }
                }
            }
        ];

        const columns1 = [
            {
                name: "label",
                label: "Title",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "address",
                label: "Address",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpFromDate",
                label: "CP From Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "cpToDate",
                label: "CP To Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "pricePerKL",
                label: "Price Per KL",
                options: {
                    filter: true,
                    sort: true,
                }
            }
        ];


        const options = {
            filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none",
            onRowsDelete: (rowsDeleted) => {
                for (var key in rowsDeleted.data) {
                    console.log(rowsDeleted.data[key].index)
                    this.delete(dataArr[rowsDeleted.data[key].index].id)
                }
            }
        };

        let newAddress = null;
        if (this.state.toggleAddress) {
            newAddress = (
                <div>
                    <Modal isOpen={true}
                        style={{ width: "1200px", display: "block" }}
                    >
                        <Card style={{ width: "50rem" }}>
                            <CardBody>
                                <ModalHeader>New Address</ModalHeader>
                                <ModalBody>
                                    <Form>
                                        <Form.Row>
                                            <Col>
                                                <Form.Group controlId="address">
                                                    <Form.Control placeholder="address"
                                                        value={this.state.address}
                                                        onChange={this.newAddressHandler}
                                                    ></Form.Control>
                                                    {this.addressValidator.message('Address', this.state.address, 'required')}
                                                </Form.Group>
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            <Col>
                                                <Form.Group controlId="adlabel">
                                                    <Form.Control placeholder="Title"
                                                        value={this.state.label}
                                                        onChange={this.newAddressHandler}
                                                    ></Form.Control>
                                                    {this.addressValidator.message('Title', this.state.label, 'required')}
                                                </Form.Group>
                                            </Col>
                                        </Form.Row>

                                    </Form>
                                    <Button
                                        style={{ marginTop: "10px" }}
                                        onClick={this.newAddressClickEventHandler}
                                        variant="outline-success" >
                                        Check  </Button>

                                    {this.state.toggleCheckAddress ? (
                                        <div className="col-md-12" style={{ marginTop: "10px" }} >
                                            {navigator.onLine ? <GeoCoding address={this.state.address} callbackFromParent={this.myCallback} /> : "You Are Not Connected To Internet"}
                                        </div>
                                    ) : null}
                                </ModalBody>
                                <ModalFooter>
                                    <Button variant="outline-success" disabled={this.disableSubmit}
                                        onClick={this.toggleNewAddressModal} >
                                        Submit
                      </Button>
                                    <Button variant="outline-success"
                                        onClick={this.toggleNewAddressModalCancel} >
                                        Cancel
                      </Button>
                                </ModalFooter>
                            </CardBody>
                        </Card>
                    </Modal>
                </div>
            );
        }

        let zone = null;

        if (this.state.lat !== 0 && this.state.lng !== 0) {

            if (this.state.zoneFlag) {
                zone = (<AddressZone lat={this.state.lng} lng={this.state.lat} callbackFromZone={this.myZoneCallback}></AddressZone>)
            }

        }

        let statusEdit = (<form>
            <div className="kt-heading kt-heading--md"><b>Contract Details</b></div>
            <div className="kt-form__section kt-form__section--first">
                <div className="kt-wizard-v1__form">
                    <div className="row">
                        <div className="col-lg-4">
                            <label><b>From</b></label>
                            <DatePickerInput locale='en' className='my-custom-datepicker-component'
                                displayFormat="DD-MM-YYYY"
                                value={this.state.contractPriceFromDate}
                                maxDate={this.state.contractPriceToDate}
								readOnly={true}
                                minDate={this.state.contractPriceToDate}
                                selected={this.state.contractPriceFromDate ? moment(this.state.contractPriceFromDate) : null}
                                onChange={this.handleChange2} />
                            {/* {
                        this.state.fcDueByRequired &&
                        <span className="form-text text-muted">Please enter your FC Due By.</span>
                      } */}
                        </div>
                        <div className="col-lg-3">
                        </div>
                        <div className="col-lg-4">
                            <label><b>To</b></label>
                            <DatePickerInput locale='en' className='my-custom-datepicker-component'
                                displayFormat="DD-MM-YYYY" minDate={this.state.contractPriceFromDate} disabled={this.state.contractPriceFromDate === null ? true : false}
								readOnly={true}
                                value={this.state.contractPriceToDate}
                                selected={this.state.contractPriceToDate ? moment(this.state.contractPriceToDate) : null}
                                onChange={this.handleChange3} />
                            {/* {
                        this.state.fcDueByRequired &&
                        <span className="form-text text-muted">Please enter your FC Due By.</span>
                      } */}
                        </div>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-lg-4">
                        </div>
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label><b>Price per KL</b></label>
                                <input type="text" className="form-control" id="pdPricePerKL" name='Price per KL' placeholder="Price per KL" value={this.state.pricePerKL} onChange={this.handleUserFormFields} style={{ fontWeight: 'bold' }} />
                                {
                                    this.pdValidator.message('Price per KL', this.state.pricePerKL, 'integer')
                                }
                            </div></div>
                    </div>
                </div>
            </div>
        </form>
        )

        let editStatuss = null;
        if (this.state.editPrice) {
            editStatuss = (
                <Modal
                    isOpen={true}
                    // fade={false}
                    // toggle={this.to}
                    style={{ width: "1200px", display: "block" }}
                >
                    <Card style={{ width: "50rem" }}>
                        <CardBody>
                            <ModalHeader>Edit Contract Details for - {this.state.customerData.apartmentName}</ModalHeader>
                            <ModalBody>
                                {statusEdit}
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="outline-primary" onClick={() => this.save()}>
                                    Save </Button>&nbsp;&nbsp;&nbsp;
                                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
                            </ModalFooter>
                        </CardBody>
                    </Card>
                </Modal>
            );
        }

        let showUpdateBtton = "";
        let showDeliveryAdderss = "";
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
            //         showUpdateBtton = <Button className="float-right"
            //             variant="outline-success"
            //             style={{ marginTop: "25px", width: "200px" }}
            //             onClick={() => this.editPriceHandler()}>
            //             Update Contract Info
            //  </Button>
            showDeliveryAdderss = (<Tab eventKey="deliveryAddress" title="Delivery Address">
                <div>
                    <Button className="float-right"
                        variant="outline-success"
                        style={{ marginTop: "10px", width: "150px", marginRight: "25px" }}
                        onClick={() => this.newAddress1()}>
                        Add Address
 </Button></div>
                {newAddress}
                {zone}
                <div>
                    <MUIDataTable
                        title={"Delivery Address List"}
                        data={dataArr}
                        columns={columns}
                        options={options} />
                </div>
            </Tab>)
        }

        let contractPriceTab = ""
        if (this.props.userRole === "Apartment Customer") {
            contractPriceTab = (<Tab eventKey="contractPricing" title="Contract Pricing">
                {showUpdateBtton}
                <MUIDataTable
                    data={dataArr}
                    columns={columns1}
                    options={options} />
            </Tab>)
        }

        let breadCrumbForUser = ""
        let vipCustomerTab = ""
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item
                    onClick={() => this.nextPath("/aprt-customer/customer-list")}
                >
                    Customer List
      </Breadcrumb.Item>

                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
            // vipCustomerTab = (<Form.Group className="col-lg-4" as={Col}>
            //     <Form.Label>VIP Customer:</Form.Label>
            //     <Form.Control
            //         type="text"
            //         value={this.state.customerData.vipCustomer === 'YES' ? 'Yes' : 'No'}
            //     ></Form.Control>
            // </Form.Group>)

        } else {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
        }

        return (<>

            {breadCrumbForUser}
            {editStatuss}
            <div>
                <Card>
                    <Card.Body>
                        <Card.Title style={{ fontWeight: "bold", fontSize: "20px" }}>
                            Customer Details - {this.state.customerData.apartmentName}
                            <Button className="float-right"
                                variant="outline-success"
                                style={{ marginTop: "25px", width: "150px" }}
                                onClick={() => this.nextPath("/aprt-customer/customer-edit", this.state.customerId)}>
                                Edit
                  </Button>
                        </Card.Title>
                        <br />
                        <br />
                        <Tabs defaultActiveKey="basic-details">
                            <Tab eventKey="basic-details" title="Basic">
                                <Form>
                                    <Form.Row>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Apartment Name:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.apartmentName} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        {/* <Form.Group as={Col}>
                                            <Form.Label> Phone Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.apartmentPhoneNumber} disabled
                                            ></Form.Control>
                                        </Form.Group> */}
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Association Name:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.associationName} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label>Door Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.doorNumber}
                                                // + "," + this.state.customerData.streetName + "," + this.state.customerData.area} 
                                                disabled
                                            ></Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label>Street Name:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.streetName}

                                                disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label>Area:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.area}
                                                disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label> City:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.city} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Landmark</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.landmark} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Pincode:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pincode} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label> Apartment Type:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.apartmentType} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label>Road Size (in ft)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.roadSize} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>


                            <Tab eventKey="ApartmentDetails" title="Apartment Details">
                                <Form>
                                    <Form.Row>
                                        <Form.Group as={Col} className="col-lg-4">
                                            <Form.Label>Apartment Mobile Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.apartmentPhoneNumber} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label>Distance between Gate & Sump (in ft):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.distanceBetweenGateAndSump} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label>Number of Towers</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.numberOfTowers} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label> Number of Homes</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.numberOfHomes} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col}>
                                            <Form.Label> Sump/Tank Capacity (in kl):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.tankCapacity} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label> Daily Need (in kl):</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.dailyNeed} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label>Preferred TDS:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.totalDissolvedSolids} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>


                                </Form>
                            </Tab>



                            <Tab eventKey="poc" title="POC">
                                <Form>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label> Contact Person 1:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pocName1} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label>Contact Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pocContactNumber1} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label> Contact Person 2:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pocName2} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col}>
                                            <Form.Label>Contact Number:</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.customerData.pocContactNumber2} disabled
                                            ></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>

                            {showDeliveryAdderss}
                            {contractPriceTab}
                        </Tabs>
                    </Card.Body>
                </Card>
            </div>
        </>
        );
    }
}
const mapStateToProps = (state /*, ownProps*/) => {
    return {
        userRole: state.auth.user[0].userType,
        userId: state.auth.user[0].id
    }
}

export default connect(
    mapStateToProps,
    null
)(TankDetails)